import moment from "moment";
import { nanoid } from "nanoid";
import constants from "../constants";
import useLogout from "../Hooks/useLogout";
import { ZoomMtg } from "@zoom/meetingsdk";
import { getDataFromStorage } from "../util";
import { useLocation, useNavigate } from "react-router-dom";
import ModuleHooks from "../Hooks/ModuleHooks";
import useAxiosPrivate from "../Hooks/useAxiosPrivate";
import { createContext, useRef, useState } from "react";
import useCommonFunctionHooks from "../Hooks/useCommonFunctionHooks";

const AlertContext = createContext({});

export const AlertProvider = ({ children }) => {
  const logout = useLogout();
  const axios = useAxiosPrivate();
  const { handlePopupStates, clearPopupStates } = ModuleHooks();
  const location = useLocation();

  const useCommonFunctionHks = useCommonFunctionHooks();

  const navigate = useNavigate();
  const [contentType, setContentType] = useState("0");

  let register = useRef(1);
  let filccld = useRef([]);
  let allWindowsBlurred = useRef(false);

  const countPicture = useRef(0);
  const webCamRef = useRef(null);
  const stopProctoring = useRef({});
  const numberOfPicsToTake = useRef(0);
  const assignmentSubmissionFiles = useRef([]);

  const [showSupAdminControls, setShowSupAdminControls] = useState(false)
  const [testDetail, setTestDetail] = useState({});
  const [currentStep, setCurrentStep] = useState(0);
  const [initialJobs, setInitialJobs] = useState([]);
  const [dashBoardId, setDashboardId] = useState(null);
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [batchGridView, setBatchGridView] = useState(false);
  const [showInstructions, setShowInstructions] = useState(false);
  const [leaderboardTestDetail, setLeaderBoardTestDetail] = useState();
  const [openRecommendedList, setOpenRecommendedList] = useState(false);

  const [filters, setFilters] = useState({
    search: "",
    jobType: "",
    location: "",
    experience: 0,
  });

  const [svg, setSvg] = useState("");
  const [msg, setMsg] = useState("");
  const [qnNo, setQnNo] = useState(0);
  const [lpId, setLpId] = useState(0);
  const [auth, setAuth] = useState({});
  const [libId, setLibId] = useState(0);
  const [topic, setTopic] = useState({});
  const [title, setTitle] = useState("");
  const [lists, setLists] = useState([]);
  const [token, settoken] = useState("");
  const [testId, setTestId] = useState(0);
  const [show, setShow] = useState(false);
  const [module, setModule] = useState({});
  const [libType, setLibType] = useState();
  const [status, setStatus] = useState("");
  const [lpData, setLpData] = useState({});
  const [state, setState] = useState(false);
  const [batchId, setBatchId] = useState(0);
  const [show1, setShow1] = useState(false);
  const [tagList, setTagList] = useState([]);
  const [profile, setProfile] = useState([]);
  const [topicId, setTopicId] = useState("");
  const [comment, setComment] = useState("");
  const [btnText, setBtnText] = useState("");
  const [dbStatus, setDbStatus] = useState(0);
  const [btnText2, setBtnText2] = useState("");
  const [testData, setTestData] = useState({});
  const [isScore, setIsScore] = useState(false);
  const [topicList, setTopicList] = useState([]);
  const [assignQns, setAssignQns] = useState({});
  const [userBatch, setUserBatch] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [showMain, setShowMain] = useState(false);
  const [isUnAuth, setIsUnAuth] = useState(false);
  const [resultCode, setResultCode] = useState(0);
  const [lpConfigId, setLpConfigId] = useState(0);
  const [content2, setContent2] = useState(false);
  const [registered, setRegistered] = useState(0);
  const [batchNames, setBatchNames] = useState([]);
  const [rejectData, setRejectData] = useState({});
  const [verifyImg, setVerifyImg] = useState(null);
  const [reportdata, setreportdata] = useState({});
  const [bannerData, setBannerData] = useState([]);
  const [isComment, setIsComment] = useState(false);
  const [isFixedQn, setIsFixedQn] = useState(false);
  const [isEditJob, setIsEditJob] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [approveData, setApproveData] = useState({});
  const [contentData, setContentData] = useState({});
  const [learnername, setLearnerName] = useState("");
  const [selectedTag, setSelectedTag] = useState([]);
  const [fromReport, setFromReport] = useState(false);
  const [startVideo, setStartVideo] = useState(false);
  const [isTakeTest, setIsTakeTest] = useState(false);
  const [lpmtopicqnno, setlpmtopicqnno] = useState(0);
  const [testActive, setTestActive] = useState(false);
  const [lpGridView, setLpGridView] = useState(false);
  const [learnerNotes, setLearnerNotes] = useState("");
  const [currentBatch, setCurrentBatch] = useState({});
  const [expandedJob, setExpandedJob] = useState(null);
  const [refreshToken, setrefreshToken] = useState("");
  const [showPrevBtn, setShowPrevBtn] = useState(false);
  const [showNextBtn, setShowNextBtn] = useState(false);
  const [openJobForm, setOpenJobForm] = useState(false);
  const [Loginstatus, setLoginStatus] = useState(false);
  const [reportfilters, setreportfilters] = useState([]);
  const [testReqDetail, setTestReqDetail] = useState({});
  const [reportColumns, setReportColumns] = useState([]);
  const [camAvailable, setCamAvailable] = useState(false);
  const [locationAvailable, setLocationAvailable] = useState(false);
  const [proctorLocation, setProctorLocation] = useState(null);
  const [locationError, setLocationError] = useState(null);
  const [curaccessor, setcuraccessor] = useState("hello");
  const [moduleActive, setModuleActive] = useState(false);
  const [downloadWidget, setDownloadWidget] = useState(0);
  const [currentEditJob, setCurrentEditJob] = useState({});
  const [codingTestData, setCodingTestData] = useState({});
  const [isstableState, setIsStableState] = useState(true);
  const [sessionDetails, setSessionDetails] = useState({});
  const [updateLeftNav, setUpdateLeftNav] = useState(false);
  const [showSaqLaqAns, setShowSaqLaqAns] = useState(false);
  const [submissionFiles, setSubmissionFiles] = useState([]);
  const [captureBtnHide, setCaptureBtnHide] = useState(true);
  const [registerNotify, setRegisterNotify] = useState(false);
  const [fromCodeEditor, setFromCodeEditor] = useState(false);
  const [isFullScreensp, setIsFullScreensp] = useState(false);
  const [instructionDetail, setInstructionPage] = useState({});
  const [isDashBoardEdit, setIsDashBoardEdit] = useState(false);
  const [showNotify, setShowNotify] = useState({ show: false });
  const [showInstruction, setShowInstruction] = useState(false);
  const [isAddSubmission, setIsAddSubmission] = useState(false);
  const [learnerVideoLink, setLearnerVideoLink] = useState(null);
  const [breadCrumbsOption, setBreadCrumbsOption] = useState([]);
  const [isEditAttendance, setIsEditAttendance] = useState(false);
  const [isEditSubmission, setIsEditSubmission] = useState(false);
  const [assignmentTestData, setAssignmentTestData] = useState({});
  const [isVersionUpToDate, setIsVersionUpToDate] = useState(null);
  const [takeMcqAndDesTest, setTakeMcqAndDesTest] = useState(false);
  const [changeHeaderValue, setChangeHeaderValue] = useState(false);
  const [showConfirmNotify, setShowConfirmNotify] = useState(false);
  const [notificationPayload, setNotificationPayload] = useState({});
  const [stablePageforBackbtn, setStablePageforBackbtn] = useState(1);
  const [loadingLeaderboard, setLoadingLeaderboard] = useState(false);
  const [stableTextforBackbtn, setStableTextforBackbtn] = useState("");
  const [selectedLearningPath, setSelectedLearningPath] = useState({});
  const [stableStateforBackbtn, setStableStateforBackbtn] = useState("");
  const [prevreportfiltertypes, setprevreportfiltertypes] = useState([]);
  const [noPercentile, setNoPercentile] = useState(true);
  const [selectedScope, setSelectedScope] = useState("all");

  const [currentEditDashboardMetaData, setCurrentEditDashboardMetaData] =
    useState({});

  const [extensionDate, setExtensionDate] = useState(
    moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
  );

  const [userProfilePic, setUserProfilePic] = useState(
    localStorage.getItem("picture"),
  );

  // Button

  const [hierarchy, setHierarchy] = useState({});
  const [buttonSize, setButtonSize] = useState("");
  const [buttonIcon, setButtonIcon] = useState({});
  const [destructive, setDestructive] = useState(false);
  const [buttonFunction, setButtonFunction] = useState();
  const [buttonDisable, setButtonDisable] = useState(false);

  // content

  const [selectque, setselectque] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isqueReport, setisqueReport] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [referenceLinks, setReferenceLinks] = useState([]);
  const [selectedLibType, setSelectedLibType] = useState(0);
  const [tableShowStatus, setTableShowStatus] = useState(0);

  // content end

  //coding

  const testCasesRef = useRef([]);
  const tabSwitchCount = useRef(0);
  const solutionLanguageId = useRef(0);
  const isInputVariable = useRef(false);
  const isLearnerQuitQns = useRef(false);
  const callAllTestCases = useRef(false);
  const isAdminSubmitTimeout = useRef(false);

  let [preview, setPreview] = useState(false);
  let [codeDetails, setCodeDetails] = useState({});
  let [breadCrumbsData, setBreadCrumbsData] = useState([]);

  const [score, setScore] = useState(0);
  const [count, setCount] = useState(0);
  const [output, setOutput] = useState("");
  const [theme, setTheme] = useState(false);
  const [language, setLanguage] = useState([]);
  const [tsCoBkup, setTsCoBkup] = useState({});
  const [timeLimit, setTimeLimit] = useState(0);
  const [learnerId, setLearnerId] = useState(0);
  const [showBlink, setShowBlink] = useState(false);
  const [showScore, setShowScore] = useState(false);
  const [learnerCode, setLearnerCode] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [showReject, setShowReject] = useState(false);
  const [commentsData, setCommentsData] = useState([]);
  const [showApprove, setShowApprove] = useState(false);
  const [inputVariable, setInputVariable] = useState("");
  const [showComments, setShowComments] = useState(false);
  const [editorTheme, setEditorTheme] = useState("tomorrow");
  const [selectedLanguage, setSelectedLanguage] = useState({});
  const [isShowTimeAlert, setIsShowTimeAlert] = useState(false);
  const [makeRunTestCase, setMakeRunTestCase] = useState(false);
  const [commentAttachment, setCommentAttachment] = useState([]);
  const [runTestResultCode, setRunTestResultCode] = useState([]);
  const [timeComplexityResult, setTimeComplexityResult] = useState(null);
  const [outputWindowHeight, setOutputWindowHeight] = useState(8);
  const [showBreadCrumbsData, setShowBreadCrumbsData] = useState({});
  const [mockTestReportTopic,setMockTestReportTopic] = useState([]);
  const [mockTestReportCurrentTopic,setMockTestReportCurrentTopic] = useState(null);
  const [problemWindowHeight, setProblemWindowHeight] = useState(25);

  //coding end

  // Mcq

  const duration = useRef();
  const interval = useRef();
  const answerRef = useRef({});
  const matchqnCount = useRef(0);
  const hasRendered = useRef(false);
  const backupTestDataq = useRef({});

  /* pract MCQ */
  const PractSingleQnId = useRef("");
  const PractSingleQnAns = useRef(false);
  const PractSingleQnFinalSubmit = useRef(false);
  const [showHalfDonut, setHalfDonut] = useState(false);
  const [halfDonutChart, setHalfDonutChart] = useState({});
  const [practSingleQnAns, setPractSingleQnAns] = useState();

  let [comingObj, updateComingObj] = useState({});

  const [queInd, setQueInd] = useState(0);
  const [secInd, setSecInd] = useState(0);
  const [testMode, setTestMode] = useState(0);
  const [action, setAction] = useState(false);
  const [ansStats, setAnsStats] = useState({});
  const [testStats, setTestStats] = useState({});
  const [descScores, setDescScores] = useState({});
  const [apiLoaded, setApiLoaded] = useState(false);
  const [mcqTestData, setMcqTestData] = useState({});
  const [isTestData, setIsTestData] = useState(false);
  const [prevButton, setPrevButton] = useState(false);
  const [nextButton, setNextButton] = useState(false);
  const [totalSecScore, setTotalSecScore] = useState(0);
  const [totalTestScore, setTotalTestScore] = useState(0);
  const [testPageShow, setTestPageShow] = useState(false);
  const [backupTestData, setBackupTestData] = useState({});
  const [totalLearnerScore, setTotalLearnerScore] = useState(0);
  const [filterQuestionCount, setFilterQuestionCount] = useState(null);
  const [currentDashboardMetaData, setCurrentDashboardMetaData] = useState({});

  // const [answers, setAnswers] = useState({});

  const [questionContainerSingle, updateQuestionContainerSingle] =
    useState(false);

  const [queLen, setQueLen] = useState(
    comingObj.hasOwnProperty("sections")
      ? comingObj.sections[secInd].questions.length
      : null,
  );

  const [secLen, setSecLen] = useState(
    comingObj.hasOwnProperty("sections") ? comingObj.sections.length : null,
  );

  const [secObj, setSecObj] = useState(
    comingObj.hasOwnProperty("sections") ? comingObj.sections[secInd] : null,
  );

  const [queObj, setQueObj] = useState(
    comingObj.hasOwnProperty("sections")
      ? comingObj.sections[secInd].questions[queInd]
      : null,
  );

  const [optObj, setOptObj] = useState(
    status !== constants.QUESTION_STATUS.SUBMITTED
      ? comingObj.hasOwnProperty("sections") &&
        filterQuestionCount != null &&
        filterQuestionCount > 0
        ? comingObj.sections[secInd].questions[queInd]?.options
        : null
      : null,
  );

  //learning path
  const [courseData, setCourseData] = useState(null);

  // MCQ End

  const [isPracticeRetake, setIsPracticeRetake] = useState(false); // handling practice retake
  /* changing learner */

  const [changelearner, setChangeLearner] = useState(false);

  /* moved from app.js */

  const [seconds, setSeconds] = useState(null);
  const [moduleList, setModuleList] = useState([]);
  // const [isFirstLoggedIn, setIsFirstLoggedIn] = useState(false);

  /* state for dashboard */

  const [batchName, setBatchName] = useState();
  const [leaderBoardData, setLeaderBoardData] = useState([]);
  const [competitiveData, setCompetitiveData] = useState([]);
  const [dashBoardDetails, setDashBoardDetails] = useState([]);
  const [ActivityData, setActivityData] = useState([]);
  const [completeAssignmentsData, setCompleteAssignmentsData] = useState([]);

  /* common popup states */

  const [isWobtnPopup, setIsWoBtnPopup] = useState(false);
  const [isCommonPopup, setIsCommonPopup] = useState(false);
  const [commonPopupTitle, setCommonPopupTitle] = useState("");
  const [commonPopupBodyDesc, setCommonPopupBodyDesc] = useState("");
  const [commonPopupTitleDesc, setCommonPopupTitleDesc] = useState("");
  const [commonPopupBodyComponent, setCommonPopupBodyComponent] = useState();
  const [isCommonPopupCloseIcon, setIsCommonPopupCloseIcon] = useState(false);

  const [iscommonPopupBodyComponent, setIsCommonPopupBodyComponent] =
    useState(false);

  const [commonPopupBtnSize, setCommonPopupBtnSize] = useState("");
  const [commonPopupSecBtnTxt, setCommonPopupSecBtnTxt] = useState("");
  const [commonPopupSecBtnFunc, setCommonPopupSecBtnFunc] = useState();
  const [commonPopupSingleBtnTxt, setCommonPopupSingleBtnTxt] = useState("");
  const [commonPopupSingleBtnFunc, setCommonPopupSingleBtnFunc] = useState();
  const [iscommonPopupSingleBtn, setIsCommonPopupSingleBtn] = useState(false);
  const [commonPopupPrimaryBtnTxt, setCommonPopupPrimaryBtnTxt] = useState("");
  const [commonPopupPrimaryBtnFunc, setCommonPopupPrimaryBtnFunc] = useState();

  const [isAdmin, setIsAdmin] = useState(
    getDataFromStorage("role") === constants.Roles.admin ||
      getDataFromStorage("role") === constants.Roles.trainer ||
      getDataFromStorage("role") === constants.Roles.super_admin
      ? true
      : false,
  );

  const [assignQnDetailsForLearner, setAssignQnDetailsForLearner] = useState(
    {},
  );

  const [batchLearnerListForEvaluation, setBatchLearnerListForEvaluation] =
    useState([]);

  const [isSubmitted, setIsSubmitted] = useState(false);

  let postViewTest = useRef(1);

  /* transition Box */

  const [currentPage, setCurrentPage] = useState(1);
  const [showTimer, setShowTimer] = useState(false);
  const [showtransition, setshowtransition] = useState(false);

  // video qn

  let qnTrack = useRef(0);

  const videoQn = useRef();
  const videoQnNo = useRef(0);
  const questionListObj = useRef([]);
  const showSubmitBtn = useRef(false);
  const exitVdoSubmit = useRef(false);
  const timeVdoSubmit = useRef(false);
  const sectionWithQuestions = useRef();

  const [VideoSaved, setVideoSaved] = useState(0);
  const [clcikedMenu, setClickedMenu] = useState(1);
  const [disableNxtBtn, setDisableNxtBtn] = useState(false);
  const [showTranscript, setShowTranscript] = useState(false);
  const [updatingStates, setUpdatingStates] = useState(false);
  const [singleVdoSubmit, setSingleVdoSubmit] = useState(false);
  const [hideSubmitVideoQn, setHideSubmitVideoQn] = useState(true);

  const [testPageShowReload, setTestPageShowReload] = useState(false);

  const showTranscriptFunc = () => {
    setShowTranscript(!showTranscript);
  };

  const [verifyMsg, setVerifyMsg] = useState({});

  /* Zoom content*/

  const ZoomBatchStudents = useRef({});

  let [participants, setparticipants] = useState([]);

  const [showzoommodal, setshowzoommodal] = useState(false);
  const [showwarnmodal, setshowwarnmodal] = useState(false);
  const [showremovefromtestmodal, setshowremovefromtestmodal] = useState(false);

  const [showremovefrombatchmodal, setshowremovefrombatchmodal] =
    useState(false);
  const [isJoinZoom, setIsJoinZoom] =
    useState(false); /* TODO: Zoom Integration */
  const setZoomBatchStudents = (batchdata) => {
    ZoomBatchStudents.current = batchdata;
  };

  const setshowzoommodalfunction = (value) => {
    setshowzoommodal(value);
  };

  const setshowwarnmodalfunction = (value) => {
    setshowwarnmodal(value);
  };

  const setshowremovefromtestmodalfunction = (value) => {
    setshowremovefromtestmodal(value);
  };

  const setshowremovefrombatchmodalfunction = (value) => {
    setshowremovefrombatchmodal(value);
  };

  /* admin  states */

  const [lpData2, setLpData2] = useState({
    type: 1,
    lpDes: "",
    lpIcon: "",
    lpName: "",
    status: "",
    id: nanoid(),
    moduleId: "",
    libTypeId: 2,
    lpContent: "",
    lpShortDes: "",
    iconFileName: "",
    isAddTest: false,
    parentModules: [
      {
        name: "",
        description: "",
      },
    ],
    modules: [
      {
        id: 1,
        key: nanoid(),
        status: "new",
        moduleName: "",
        moduleData: [],
      },
    ],
  });

  const [cellobj, setcellobj] = useState({});
  const [isAddLp, setIsAddLp] = useState(false);
  const [fromMenu, setFromMenu] = useState(false);
  const [isFromLp, setIsFromLp] = useState(false);
  const [isFromBatch, setIsFromBatch] = useState(false);
  const [userReportData, setUserReportData] = useState([]);
  const [isAddLpModule, setIsAddLpModule] = useState(false);
  const [isOldLpDetail, setIsOldLpDetail] = useState(false);
  const [reportSortState, setReportSortState] = useState([]);
  const [isBatchDetails, setIsBatchDetails] = useState(false);
  const [fromMenuToEditTest, setFromMenuToEditTest] = useState(false);
  const [openSandpackEditor, setOpenSandpackEditor] = useState(false);
  const [filterUserReportData, setFilterUserReportData] = useState([]);
  const [mcqAndDesTestAndLpId, setMcqAndDesTestAndLpId] = useState({});
  const [batchDetails, setBatchDetails] = useState({ learningpath: [] });
  const [fromList, setFromList] = useState({ isFromList: false, libType: "" });
  const [companyInfo, setCompanyInfo] = useState([]);
  const [fetchCompanyData, setFetchCompanyData] = useState(false);
  const [companySearch, setCompanySearch] = useState("");
  const [showArchivedCompanies, setShowArchivedCompanies] = useState(false);
  const [archivedCompanyCount, setArchivedCompanyCount] = useState(0);
  const [moduleExpandKey, setModuleExpandKey] = useState(
    lpData2.modules.length > 0 ? [lpData2.modules[0].key] : [],
  );

  const [oldTestConfig, setOldTestConfig] = useState({
    oldTestData: {},
    isOldTestConfig: false,
  });

  /* Coding Challenge from lp */

  const [isCodingChallenge, setIsCodingChallenge] = useState(false);

  const [CCTestData, setCCTestData] = useState({
    qnId: null,
    topicId: null,
    ccWithFixedQn: false,
  });

  /* Coding Challenge from lp -- */

  const screenType = useRef("desktop");
  const screenWidth = useRef(window.innerWidth);
  const screenHeight = useRef(window.innerHeight);

  let prevlpid = useRef(0);
  let prevctdata = useRef([]);
  let prevtypesobj = useRef([]);
  let testopened = useRef(false);
  let prevmodulescol = useRef([]);
  let learnerdataref = useRef([]);
  let prevreporttypes = useRef([]);
  let prevreportstatus = useRef([]);
  let prevreporttopics = useRef([]);
  let prevglobalfilter = useRef([]);
  let prevhiddencolumns = useRef([]);
  let prevvisiblecolumns = useRef([]);
  let prevreporttypevalues = useRef([]);
  let prevreportlearnerdata = useRef([]);

  /* user points table */
  const [fromRecommended, setFromResommended] = useState(false);
  const [studentDetailSL, setStudentDetailSL] = useState({});
  const [selectedBid, setSelectedBid] = useState({ bid: 0, lid: 0 });

  const isFromProfile = useRef(false);

  const streamRef = useRef(null);

  const setlearnerdataref = (studentdata) => {
    learnerdataref.current = studentdata;
  };

  const settestopened = (topened) => {
    testopened.current = topened;
  };

  const setprevctdata = (ctdata) => {
    prevctdata.current = ctdata;
  };

  const setprevtypesobj = (typesobj) => {
    prevtypesobj.current = typesobj;
  };

  const showAnswer = () => {
    setShowSaqLaqAns(!showSaqLaqAns);
  };

  const setprevreporttypevalues = (preporttypevalues) => {
    prevreporttypevalues.current = preporttypevalues;
  };

  const setprevreportlearnerdata = (preportlearnerdata) => {
    prevreportlearnerdata.current = preportlearnerdata;
  };

  const setprevlpid = (plpid) => {
    prevlpid.current = plpid;
  };

  const setprevreportstatus = (preportstatus) => {
    prevreportstatus.current = preportstatus;
  };

  const setprevreporttypes = (preporttypes) => {
    prevreporttypes.current = preporttypes;
  };

  const setprevreporttopics = (preporttopics) => {
    prevreporttopics.current = preporttopics;
  };

  const setprevhiddencolumns = (phiddencolumns) => {
    prevhiddencolumns.current = phiddencolumns;
  };

  const setprevglobalfilter = (pglobalfilter) => {
    prevglobalfilter.current = pglobalfilter;
  };

  const setprevvisiblecolumns = (pcolumns) => {
    prevvisiblecolumns.current = pcolumns;
  };

  const setprevmodulescol = (modcol) => {
    prevmodulescol.current = modcol;
  };

  const LoadDeviceDetails = () => {
    screenWidth.current = window.innerWidth;
    screenHeight.current = window.innerHeight;

    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      )
    ) {
      screenType.current = "mobile";
      return;
    }

    if (
      /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
        navigator.userAgent.toLowerCase(),
      )
    ) {
      screenType.current = "tablet";

      return;
    } else {
      screenType.current = "desktop";

      return;
    }
  };

  const setPostViewTest = (Setting) => {
    postViewTest.current = Setting;
  };

  /* Report new states */
  const [searchInput, setSearchInput] = useState("");
  const [searchText, setSearchText] = useState("");
  const [reportTopics, setReportTopics] = useState([]);
  const [isReportClick, setIsReportClick] = useState(false);
  const [hiddenColumnsInTable, setHiddenColumnsInTable] = useState([]);

  /* chapter count */
  const [selectedChapters, setSelectedChapters] = useState([]);
  const [selectedModule, setSelectedModule] = useState(null);
  const [hoveredModule, setHoveredModule] = useState(null);
  const [appliedModules, setAppliedModules] = useState({}); // stores chapters applied for each module
  const [selectedDropdown, setSelectedDropdown] = useState({
    college: null,
    status: null,
    branch: null,
  }); // status which selected
  const [openCDropdown, setOpenCDropdown] = useState(false);
  const [openModuleDropdown, setOpenModuleDropdown] = useState(false);

  /* College */
  const [collegeList, setCollegeList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [selectedcollege, setSelectedcollege] = useState("");
  const [selectedBranch, setSelectedBranch] = useState("");

  /* Univeristy */
  const [universityList, setUniversityList] = useState([]);

  const [reportStatus, setReportStatus] = useState([
    {
      checked: false,
      disabled: false,
      label: "Yet To Start",
      value: constants.PROGRESS_STATUS.LOCKED,
    },
    {
      checked: false,
      disabled: false,
      label: "Submitted",
      value: constants.PROGRESS_STATUS.TO_BE_EVALUATED,
    },
    {
      checked: false,
      disabled: false,
      label: "In Progress",
      value: constants.PROGRESS_STATUS.UNLOCKED,
    },
    {
      checked: false,
      disabled: false,
      label: "Resubmission",
      value: constants.PROGRESS_STATUS.REATTEMPT,
    },
    {
      checked: false,
      disabled: false,
      label: "Graded",
      value: constants.PROGRESS_STATUS.EVALUATED,
    },
  ]);

  const [typesAndModules, setTypesAndModules] = useState([
    // {
    //   id: 1,
    //   checked: false,
    //   disabled: false,
    //   label: "Active",
    //   value: 1,
    //   lstatus: true,
    // },
    {
      id: 2,
      value: 4,
      checked: false,
      disabled: false,
      label: "Assignment",
      libtype: true,
    },
    {
      id: 3,
      value: 5,
      checked: false,
      label: "Coding",
      disabled: false,
      libtype: true,
    },
    // {
    //   id: 4,
    //   value: "cct",
    //   checked: false,
    //   disabled: false,
    //   label: "Coding Totals",
    // },
    // {
    //   id: 5,
    //   checked: false,
    //   disabled: true,
    //   label: "Confidence",
    //   value: "confidence",
    // },
    {
      id: 6,
      value: 3,
      checked: false,
      disabled: false,
      label: "Descriptive",
      libtype: true,
    },
    {
      id: 8,
      label: "MCQ",
      value: 2,
      checked: false,
      disabled: false,
      libtype: true,
    },
    {
      id: 9,
      label: "SQL",
      value: 11,
      checked: false,
      disabled: false,
      libtype: true,
    },
    // {
    //   id: 9,
    //   checked: false,
    //   disabled: false,
    //   value: "moduletotals",
    //   label: "Module Totals",
    // },
    // {
    //   id: 10,
    //   checked: false,
    //   disabled: true,
    //   label: "Performance",
    //   value: "performance",
    // },
    {
      id: 7,
      checked: false,
      disabled: false,
      label: "Inactive",
      value: 0,
      lstatus: true,
    },
    {
      id: 11,
      checked: false,
      disabled: false,
      label: "Practice",
      value: "practice",
    },
  ]);

  const viewColumns = useRef([]);
  const viewLearnerData = useRef([]);
  const selectedColumns = useRef([]);
  const reportTableRef = useRef(null);
  const currentTypeAndModules = useRef([]);

  const [performance, setPerformance] = useState(false);
  const [resLData, setResLData] = useState({});
  const [hasMore, setHasMore] = useState(true);
  const [data, setData] = useState([]);
  const [studentPage, setStudentPage] = useState(1);
  const [mid, setMid] = useState("");
  const [lpcid, setLpcid] = useState("");
  const [qns, setQns] = useState("");
  const [lStatus, setLStatus] = useState("");
  const [libtype, setLibtype] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [totalmids, setTotalmids] = useState("");
  const [isGrandTotal, setIsGrandTotal] = useState(false);
  const [tesMode, setTesMode] = useState(constants.MODE.TEST_MODE);
  const [fromTrainer, setFromTrainer] = useState(false);
  const [isCCreator, setIsCCreator] = useState(false);
  const [isEditTC, setIsEditTC] = useState(false);

  /* sandpack editor state */

  const [sandpackFiles, setSandpackFiles] = useState({});
  const [externalDevices, setExternalDevices] = useState(false);
  const [selectedTemplate, setSeletedTemplate] = useState("React");
  const [showSandpackOptions, setShowSandpackOptions] = useState(false);
  const [isQuestionUploaded, setIsQuestionUploaded] = useState(false);
  const handleClose = () => {
    setShow(false);
    setShowConfirmNotify(false);
    setSvg("");
    setMsg("");
    setBtnText("");
    setBtnText2("");
    setResultCode("");
  };

  const handleNavigateToHome = () => {
    setLpId(lpId);
    setLpData({});
    setTheme(false);
    setCodeDetails({});
    setIsFullScreen(false);
    setEditorTheme("tomorrow");
    setFromCodeEditor(true);
    setMsg("");
    setSvg("");
    setShow(false);
    setShowConfirmNotify(false);
    setBtnText("");
    setBtnText2("");

    if (document.fullscreenElement) {
      document.exitFullscreen();
    }

    navigate("/home");
  };

  const handleRegistration = () => {
    setShowConfirmNotify(false);
    navigate("/registration");
  };

  const handleUnAuthAlert = async () => {
    setAuth({});
    try {
      setSvg("");
      setBtnText("");
      setShow(false);
      setBtnText2("");
      setResultCode("");
      setIsUnAuth(false);
      setIsBatchDetails(false);
      localStorage.removeItem("tokenKey");
      await logout();
    } catch (err) {
    } finally {
      window.location.reload();
    }
  };

  /* for admin learning path */

  const handleGetLibIdFromLp = (data, from) => {
    setOldTestConfig({ isOldTestConfig: false, oldTestData: {} });
    setFromMenu(false);
    setLpData2(data);
    if (from === "codingchallenge") {
      navigate(`/library/${5}/questionlist`);
      setIsCodingChallenge(true);
    } else {
      navigate("/library/testlist");
    }
  };

  const handleNavigateToLpAfterAddTest = (data) => {
    setShowNotify({ show: false });

    if (isOldLpDetail && isFromBatch) {
      setLpData2((prev) => ({ ...prev, ...data }));
      delete lpData2.data;
      navigate(`/batches/${sessionStorage.getItem("abatchid")}/courses`);
    } else {
      if (!isOldLpDetail) {
        setIsAddLp(true);
        setIsAddLpModule(true);
      }

      setLpData2((prev) => ({ ...prev, ...data }));
      delete lpData2.data;

      if (oldTestConfig.mocklp || data.mockuse) {
        navigate("mock/create/learningpath");
      } else {
        navigate("learningpath");
      }
    }
  };

  const handleEditTestConfig = (
    oldTestConfigData,
    moduleId,
    isEdited,
    status,
    published,
    testStatus,
  ) => {
    setFromMenu(false);

    if (!isEdited) {
      let data = oldTestConfigData[0],
        count = 0,
        uniqueId = 1;

      data.isOld = true;
      data.status = status;
      data.published = published;
      data.testStatus = testStatus;
      data.libTypeId = data.libType;
      data.testDurationUnit = "min/s";
      data.testDurationNum = data.testDuration;
      data.testDuration = data.testDuration + "m";
      data.testType = { label: data.libName, value: data.libType };

      for (let i = 0; i < data.sections.length; i++) {
        count++;
        data.sections[i].id = uniqueId;
        data.sections[i].key = nanoid();
        data.sections[i].status = status;
        data.sections[i].testStatus = testStatus;
        data.sections[i].type = testStatus === "new" ? "insert" : testStatus;
        data.sections[i].isOld = testStatus === "new" ? false : true;
        uniqueId++;
        data.sections[i].secData = data.sections[i].secData.sort(
          (a, b) => a.orderno - b.orderno,
        );
        for (let j = 0; j < data.sections[i].secData.length; j++) {
          data.sections[i].secData[j].id = uniqueId;
          data.sections[i].secData[j].key = nanoid();
          data.sections[i].secData[j].type =
            testStatus === "new" ? "insert" : testStatus;
          data.sections[i].secData[j].isOld =
            testStatus === "new" ? false : true;
          data.sections[i].secData[j].topic = {
            label: data.sections[i].secData[j].topicName,
            value: data.sections[i].secData[j].topicId,
          };
          data.sections[i].secData[j].status = status;
          data.sections[i].secData[j].desType = {
            label: data.sections[i].secData[j].configLibName,
            value: data.sections[i].secData[j].configLibType,
          };
          data.sections[i].secData[j].complexity = {
            label: data.sections[i].secData[j].complexityName,
            value: data.sections[i].secData[j].complexityId,
          };
          data.sections[i].secData[j].testStatus = testStatus;
          if (
            data.libTypeId === constants.libTypeIds.DESCRIPTIVE &&
            data.videoQn
          ) {
            data.sections[i].secData[j].durationNum =
              data.sections[i].secData[j].duration /
              (data.sections[i].secData[j].randomQnCount +
                data.sections[i].secData[j].fixedQnCount);
            data.sections[i].secData[j].durationUnit = "min/s";
          }

          if (data.libTypeId === constants.libTypeIds.CODING_CHALLENGE) {
            let languages = [];

            for (
              let k = 0;
              k < data.sections[i].secData[j].languages.length;
              k++
            ) {
              languages.push({
                value: data.sections[i].secData[j].languages[k].id,
                label: data.sections[i].secData[j].languages[k].name,
                key: nanoid(),
              });
            }

            data.sections[i].secData[j].languages = languages;
            data.sections[i].secData[j].durationNum =
              data.sections[i].secData[j].duration /
              (data.sections[i].secData[j].randomQnCount +
                data.sections[i].secData[j].fixedQnCount);
            data.sections[i].secData[j].durationUnit = "min/s";
          }

          uniqueId += 8;
        }

        setOldTestConfig({
          oldTestData: data,
          moduleId: moduleId,
          isOldTestConfig: true,
        });

        if (count === data.sections.length)
          navigate(`/library/${data.libTypeId}/test/create`);
      }
    } else {
      setOldTestConfig({
        moduleId: moduleId,
        isOldTestConfig: true,
        oldTestData: oldTestConfig.oldTestData,
      });
      navigate(`/library/${data.libTypeId}/test/${data.id}`);
    }
  };

  const handleEditedTestConfig = (data) => {
    setLpData2(data);

    if (isOldLpDetail && isFromBatch) {
      navigate(`/batches/${sessionStorage.getItem("abatchid")}/courses`);
    } else navigate("/learningpath");
  };

  const assignQuestionToLearner = (qnData) => {
    setAssignQnDetailsForLearner(qnData);
    navigate("/coding", {...location.state});
  };

  const handleMcq = (
    testid,
    lpid,
    lpconfigid,
    status,
    learnerid,
    proctored,
    testmode,
    configdata,
    learnerlist,
    fromreport,
    cellobj,
    libtypeid,
    viewTest,
    autoEval,
  ) => {
    if (isAdmin) {
      setLearnerId(learnerid);
      setFromReport(fromreport);
      setTestId(testid);
    }

    setMcqAndDesTestAndLpId({
      lpid: lpid,
      testid: testid,
      status: status,
      cellobj: cellobj,
      autoEval: autoEval,
      testmode: testmode,
      viewTest: viewTest,
      learnerid: learnerid,
      proctored: proctored,
      libtypeid: libtypeid,
      configdata: configdata,
      lpconfigid: lpconfigid,
    });

    setTakeMcqAndDesTest(true);
    navigate("/mcq");
  };

  const handleWebCamError = () => {
    setCamAvailable(false);
  };

  const handleContent = (
    data,
    lpId,
    type,
    lpConfigId,
    libId,
    status,
    learnerlist,
    fromreport,
    lid,
    cellobj,
  ) => {
    setBatchLearnerListForEvaluation(learnerlist);
    setFromReport(fromreport);
    setLearnerId(lid);

    if (data.name === null) {
      setShow(true);
      setTitle("Info");
      setMsg("There is no data to see. Contact your trainer.");
    } else {
      if (
        status === constants.PROGRESS_STATUS.REATTEMPT ||
        status === constants.PROGRESS_STATUS.UNLOCKED
      ) {
        setIsSubmitted(false);
      } else {
        setIsSubmitted(true);
      }
      setLpId(lpId);
      setLibId(libId);
      setLibType(type);
      setStatus(status);
      setContentData(data);
      setLpConfigId(lpConfigId);
      setcellobj(cellobj);

      if (type === 1) {
        try {
          if (
            data.description !== null &&
            typeof JSON.parse(data.description) === "object"
          ) {
            navigate("/content");
          } else if (
            data.description === null ||
            typeof data.description === "string"
          ) {
            navigate("/newcontent");
          } else {
            navigate("/content");
          }
        } catch (error) {
          navigate("/newcontent");
        }
      } else {
        setAssignmentTestData(data);
        navigate("/assignment");
        setTestData({
          testmode: cellobj.testMode,
          testtype: cellobj.type,
          testname: cellobj.testName,
        });
      }
    }
  };

  const handleNavContentOrAssignment = (
    data,
    lpId,
    type,
    lpConfigId,
    libId,
    status,
    learnerlist,
    fromreport,
    lid,
    cellobj,
  ) => {
    setFromReport(fromreport);
    setLearnerId(lid);

    if (data.name === null) {
      setShow(true);
      setTitle("Info");
      setMsg("There is no data to see. Contact your trainer.");
    } else {
      if (
        status === constants.PROGRESS_STATUS.REATTEMPT ||
        status === constants.PROGRESS_STATUS.UNLOCKED
      ) {
        setIsSubmitted(false);
      } else {
        setIsSubmitted(true);
      }

      if (type === 1) {
        try {
          if (
            data.description !== null &&
            typeof JSON.parse(data.description) === "object"
          ) {
            data.type = "contentEditor";
          } else if (
            data.description === null ||
            typeof data.description === "string"
          ) {
            data.type = "oldContent";
          } else {
            data.type = "contentEditor";
          }
        } catch (error) {
          data.type = "oldContent";
        }
      }

      setLpId(lpId);
      setLibId(libId);
      setLibType(type);
      setStatus(status);
      setContentData(data);
      setLpConfigId(lpConfigId);
      setcellobj(cellobj);
      setShowMain(true);
    }
  };

  const selectedQuestion = (
    question,
    module,
    topic,
    learnerId,
    status,
    lname,
    qnno,
    lpid,
    order,
    learnerList,
    fromreport,
    libtypefromreport,
    lpconfigid1,
    tld,
    accessor,
    cellobj,
  ) => {
    setcuraccessor(accessor);
    filccld.current = tld;
    setFromReport(fromreport);
    setLpConfigId(lpconfigid1);
    setLibType(libtypefromreport);
    setQnNo(order);
    setTopic(topic);
    setStatus(status);
    setModule(module);
    setLearnerName(lname);
    setlpmtopicqnno(qnno);
    setAssignQns(question);
    setLearnerId(learnerId);
    setTestId(cellobj.testId);
    setShow(false);
    setcellobj(cellobj);
    navigate("/coding");
  };

  const handlePopupOkFunc = () => {
    handleUnAuthAlert();
    clearPopupStates();
    leaveMeeting();
  };

  const handleResponse = (title, msg, isUnAuth) => {
    // Prepare the popup data
    const popupdata = {
      showpopup: true,
      title,
      bodydesc: msg,
      singlebtn: true,
      singlebtntxt: "Ok",
      singlebtnsize: "small",
      singlebtnfunt: isUnAuth ? handlePopupOkFunc : clearPopupStates,
    };

    // Call the function to handle the popup state
    handlePopupStates(popupdata);
  };

  const handleDisableUser = async () => {
    try {
      await axios.post(
        "node/zoom/batch/user/status",
        JSON.stringify({
          userIds: [getDataFromStorage("learnerid")],
          batchId: localStorage.getItem("batchid"),
          active: false,
        }),
        {
          timeout: 60000,
          headers: {
            "Content-type": "application/json",
          },
        },
      );
      {
        /* TODO: Zoom Integration */
      }
      // leaveMeeting();
    } catch (error) {
      console.error("err of disable user", error);
      if (error.message.includes("403")) {
        handleResponse("Error !", "The session token is invalid", true);
      } else {
        handleResponse(
          "Error !",
          "Something went wrong… Please, try again",
          false,
        );
      }
    }
  };

  const leaveMeeting = () => {
    ZoomMtg.getAttendeeslist({
      meetingNumber: process.env.REACT_APP_ZOOM_MEETING_NUMBER,
      success: function (res) {
        for (const attendee of res.result.attendeesList) {
          if (attendee?.userName?.includes("$")) {
            let testdata = attendee.userName.split("$$")[2]?.split(",");
            let learnerid = parseInt(testdata[3]);
            if (learnerid === parseInt(getDataFromStorage("learnerid"))) {
              ZoomMtg.leaveMeeting({
                success: () => {},
                error: (error) => {
                  console.error("Error leaving the meeting:", error);
                },
              });
            }
          }
        }
      },
      error: function (res) {
        console.log(res);
      },
    });
  };

  /* TODO: Zoom Integration */

  const createCCSingleTest = () => {
    if (CCTestData.qnId !== null) {
      setIsLoaded(true);
      axios
        .post(
          "node/admin/test/create",
          JSON.stringify(CCTestData),
          useCommonFunctionHks.getHeaderDetailsForAxios(),
        )
        .then((createTestRes) => {
          let data = createTestRes.data;

          if (data.resultCode === constants.RESULT_STATUS.SUCCESS) {
            if (data.msg.includes("Created")) {
              setIsCodingChallenge(false);
              setCCTestData({
                qnId: null,
                topicId: null,
                ccWithFixedQn: false,
              });

              let uniqueId = 1,
                newDetails = JSON.parse(JSON.stringify(lpData2)),
                testData = {
                  published: 0,
                  isEdited: false,
                  id: data.data.testId,
                  title: data.data.testname,
                  libTypeId: lpData2.libTypeId,
                };

              testData.status = "new";
              testData.testStatus = "old";

              for (let i = 0; i < newDetails.modules.length; i++) {
                if (newDetails.modules[i].id === newDetails.moduleId) {
                  newDetails.modules[i].moduleData.push(testData);
                }

                for (
                  let j = 0;
                  j < newDetails.modules[i].moduleData.length;
                  j++
                ) {
                  newDetails.modules[i].moduleData[j].moduleDataId = uniqueId;
                  newDetails.modules[i].moduleData[j].key = nanoid();
                  uniqueId++;
                }

                newDetails.modules[i].id = uniqueId;
                uniqueId++;
              }

              newDetails.isAddTest = false;

              if (isFromBatch) newDetails.status = "update";

              handleNavigateToLpAfterAddTest(newDetails);
            }
          }
        })
        .catch((createTestErr) => {
          setIsLoaded(false);
          useCommonFunctionHks.getCatchBlockDetails(createTestErr);
        })
        .finally(() => setIsLoaded(false));
    } else {
      setShowNotify({
        show: true,
        title: "Info",
        msg: "Please Select Question",
      });
    }
  };

  return (
    <AlertContext.Provider
      value={{
        msg,
        svg,
        auth,
        show,
        lpId,
        qnNo,
        title,
        libId,
        show1,
        topic,
        state,
        lists,
        lpData,
        setSvg,
        setMsg,
        status,
        module,
        testId,
        lpData2,
        setQnNo,
        seconds,
        filccld,
        setAuth,
        comment,
        setLpId,
        setShow,
        btnText,
        isAdmin,
        isAddLp,
        libType,
        cellobj,
        isScore,
        tagList,
        batchId,
        setLists,
        setShow1,
        setState,
        register,
        registered,
        setRegistered,
        setTitle,
        setLibId,
        isLoaded,
        isUnAuth,
        navigate: (path) => navigate(path),
        isFromLp,
        fromList,
        testData,
        content2,
        fromMenu,
        btnText2,
        showMain,
        prevlpid,
        setTopic,
        setModule,
        topicList,
        handleMcq,
        setLpData,
        setTestId,
        batchName,
        setStatus,
        isComment,
        isFixedQn,
        assignQns,
        webCamRef,
        locationAvailable,
        setLocationAvailable,
        proctorLocation,
        setProctorLocation,
        locationError,
        setLocationError,
        userBatch,
        setLpData2,
        bannerData,
        setTagList,
        setComment,
        setBatchId,
        lpConfigId,
        testActive,
        setBtnText,
        setIsAddLp,
        setIsScore,
        setIsAdmin,
        resultCode,
        fromReport,
        setLibType,
        isTakeTest,
        screenType,
        reportdata,
        prevctdata,
        showNotify,
        testopened,
        setSeconds,
        moduleList,
        showAnswer,
        searchText,
        searchInput,
        courseData,
        registered,
        learnername,
        showPrevBtn,
        curaccessor,
        setShowMain,
        setTestData,
        setIsLoaded,
        setBtnText2,
        contentData,
        handleClose,
        setIsUnAuth,
        setIsFromLp,
        setFromList,
        screenWidth,
        isFromBatch,
        setFromMenu,
        setContent2,
        setprevlpid,
        viewColumns,
        performance,
        showNextBtn,
        Loginstatus,
        isSubmitted,
        countPicture,
        setAssignQns,
        setIsComment,
        setUserBatch,
        setIsFixedQn,
        prevtypesobj,
        setBatchName,
        lpmtopicqnno,
        batchDetails,
        setTopicList,
        postViewTest,
        learnerNotes,
        screenHeight,
        reportTopics,
        isWobtnPopup,
        reportStatus,
        currentBatch,
        moduleActive,
        camAvailable,
        setCourseData,
        handleContent,
        setResultCode,
        setLpConfigId,
        setTestActive,
        setFromReport,
        setIsTakeTest,
        isAddLpModule,
        setreportdata,
        setBannerData,
        isstableState,
        settestopened,
        isOldLpDetail,
        oldTestConfig,
        sandpackFiles,
        setModuleList,
        showSaqLaqAns,
        changelearner,
        extensionDate,
        isCommonPopup,
        setSearchText,
        setSearchInput,
        setShowNotify,
        reportColumns,
        reportfilters,
        setprevctdata,
        testReqDetail,
        updateLeftNav,
        codingTestData,
        sessionDetails,
        setShowNextBtn,
        setShowPrevBtn,
        registerNotify,
        setcuraccessor,
        setLoginStatus,
        setIsFromBatch,
        setContentData,
        setLearnerName,
        prevmodulescol,
        learnerdataref,
        isBatchDetails,
        isFullScreensp,
        setIsSubmitted,
        setPerformance,
        reportTableRef,
        userReportData,
        fromCodeEditor,
        setModuleActive,
        showInstruction,
        setlpmtopicqnno,
        setLearnerNotes,
        setCurrentBatch,
        setBatchDetails,
        setprevtypesobj,
        reportSortState,
        prevreporttypes,
        setPostViewTest,
        isAddSubmission,
        moduleExpandKey,
        setReportTopics,
        setReportStatus,
        viewLearnerData,
        leaderBoardData,
        submissionFiles,
        typesAndModules,
        selectedColumns,
        setIsWoBtnPopup,
        setCamAvailable,
        dashBoardDetails,
        selectedQuestion,
        setShowSaqLaqAns,
        setChangeLearner,
        prevreporttopics,
        setTestReqDetail,
        setIsOldLpDetail,
        setreportfilters,
        setUpdateLeftNav,
        setIsStableState,
        setReportColumns,
        setExtensionDate,
        prevglobalfilter,
        setSandpackFiles,
        selectedTemplate,
        setOldTestConfig,
        prevreportstatus,
        isEditSubmission,
        setIsAddLpModule,
        isEditAttendance,
        setIsCommonPopup,
        commonPopupTitle,
        showConfirmNotify,
        setSessionDetails,
        setFromCodeEditor,
        setRegisterNotify,
        setUserReportData,
        setCodingTestData,
        handleUnAuthAlert,
        setIsBatchDetails,
        handleWebCamError,
        changeHeaderValue,
        instructionDetail,
        takeMcqAndDesTest,
        setprevmodulescol,
        setlearnerdataref,
        setIsFullScreensp,
        LoadDeviceDetails,
        prevhiddencolumns,
        setModuleExpandKey,
        setInstructionPage,
        assignmentTestData,
        setSeletedTemplate,
        setReportSortState,
        setprevreporttypes,
        prevvisiblecolumns,
        setLeaderBoardData,
        setIsAddSubmission,
        openSandpackEditor,
        setTypesAndModules,
        numberOfPicsToTake,
        fromMenuToEditTest,
        commonPopupBtnSize,
        setSubmissionFiles,
        setShowInstruction,
        handleRegistration,
        showSandpackOptions,
        setprevglobalfilter,
        setprevreportstatus,
        setIsEditSubmission,
        notificationPayload,
        setDashBoardDetails,
        setCommonPopupTitle,
        commonPopupBodyDesc,
        setprevreporttopics,
        setIsEditAttendance,
        setprevhiddencolumns,
        setShowConfirmNotify,
        setTakeMcqAndDesTest,
        handleNavigateToHome,
        handleGetLibIdFromLp,
        handleEditTestConfig,
        filterUserReportData,
        mcqAndDesTestAndLpId,
        setChangeHeaderValue,
        stablePageforBackbtn,
        prevreporttypevalues,
        commonPopupTitleDesc,
        commonPopupSecBtnTxt,
        hiddenColumnsInTable,
        stableTextforBackbtn,
        selectedLearningPath,
        setFromMenuToEditTest,
        setprevvisiblecolumns,
        prevreportfiltertypes,
        setAssignmentTestData,
        setCommonPopupBtnSize,
        commonPopupSecBtnFunc,
        currentTypeAndModules,
        prevreportlearnerdata,
        setOpenSandpackEditor,
        stableStateforBackbtn,
        setCommonPopupBodyDesc,
        iscommonPopupSingleBtn,
        isCommonPopupCloseIcon,
        setShowSandpackOptions,
        setNotificationPayload,
        handleEditedTestConfig,
        setSelectedLearningPath,
        setMcqAndDesTestAndLpId,
        setFilterUserReportData,
        setStablePageforBackbtn,
        setStableTextforBackbtn,
        setHiddenColumnsInTable,
        commonPopupSingleBtnTxt,
        setCommonPopupSecBtnTxt,
        setCommonPopupTitleDesc,
        assignQuestionToLearner,
        setprevreporttypevalues,
        setStableStateforBackbtn,
        commonPopupSingleBtnFunc,
        commonPopupPrimaryBtnTxt,
        setCommonPopupSecBtnFunc,
        commonPopupBodyComponent,
        setprevreportfiltertypes,
        setprevreportlearnerdata,
        assignQnDetailsForLearner,
        setIsCommonPopupSingleBtn,
        commonPopupPrimaryBtnFunc,
        setIsCommonPopupCloseIcon,
        assignmentSubmissionFiles,
        setCommonPopupSingleBtnTxt,
        iscommonPopupBodyComponent,
        setCommonPopupSingleBtnFunc,
        setCommonPopupPrimaryBtnTxt,
        setCommonPopupBodyComponent,
        setAssignQnDetailsForLearner,
        setCommonPopupPrimaryBtnFunc,
        handleNavContentOrAssignment,
        batchLearnerListForEvaluation,
        setIsCommonPopupBodyComponent,
        handleNavigateToLpAfterAddTest,
        setBatchLearnerListForEvaluation,

        // button

        hierarchy,
        buttonSize,
        buttonIcon,
        destructive,
        setHierarchy,
        setButtonSize,
        setButtonIcon,
        buttonDisable,
        setDestructive,
        buttonFunction,
        setButtonDisable,
        setButtonFunction,

        // button end

        // mcq

        queInd,
        secInd,
        queLen,
        secLen,
        secObj,
        queObj,
        optObj,
        action,
        testMode,
        interval,
        ansStats,
        duration,
        setQueInd,
        setSecInd,
        answerRef,
        setAction,
        setQueLen,
        setSecLen,
        setSecObj,
        setQueObj,
        setOptObj,
        testStats,
        apiLoaded,
        comingObj,
        prevButton,
        isTestData,
        descScores,
        nextButton,
        mcqTestData,
        setTestMode,
        setAnsStats,
        hasRendered,
        setTestStats,
        setApiLoaded,
        testPageShow,
        setPrevButton,
        setNextButton,
        setDescScores,
        totalSecScore,
        setIsTestData,
        backupTestData,
        totalTestScore,
        setMcqTestData,
        setTestPageShow,
        updateComingObj,
        backupTestDataq,
        setTotalSecScore,
        setTotalTestScore,
        setBackupTestData,
        totalLearnerScore,
        filterQuestionCount,
        setTotalLearnerScore,
        setFilterQuestionCount,
        questionContainerSingle,
        updateQuestionContainerSingle,
        // mcq end

        //content

        selectque,
        isqueReport,
        setselectque,
        currentIndex,
        isFullScreen,
        setisqueReport,
        referenceLinks,
        selectedLibType,
        setCurrentIndex,
        setIsFullScreen,
        tableShowStatus,
        setReferenceLinks,
        setSelectedLibType,
        setTableShowStatus,

        //content end

        //coding

        theme,
        count,
        score,
        output,
        profile,
        setScore,
        setCount,
        language,
        setTheme,
        showScore,
        learnerId,
        setOutput,
        showPopup,
        timeLimit,
        testDetail,
        setProfile,
        showReject,
        rejectData,
        approveData,
        setLanguage,
        selectedTag,
        codeDetails,
        editorTheme,
        learnerCode,
        currentStep,
        showApprove,
        setShowScore,
        setLearnerId,
        showComments,
        setTimeLimit,
        testCasesRef,
        commentsData,
        setShowPopup,
        setRejectData,
        setShowReject,
        inputVariable,
        setTestDetail,
        stopProctoring,
        setCurrentStep,
        captureBtnHide,
        setApproveData,
        setShowApprove,
        tabSwitchCount,
        setEditorTheme,
        setSelectedTag,
        setLearnerCode,
        setCodeDetails,
        setShowComments,
        isShowTimeAlert,
        setCommentsData,
        isInputVariable,
        makeRunTestCase,
        breadCrumbsData,
        isLearnerQuitQns,
        callAllTestCases,
        setInputVariable,
        selectedLanguage,
        isVersionUpToDate,
        breadCrumbsOption,
        setCaptureBtnHide,
        commentAttachment,
        runTestResultCode,
        timeComplexityResult,
        setBreadCrumbsData,
        setIsShowTimeAlert,
        setMakeRunTestCase,
        outputWindowHeight,
        solutionLanguageId,
        loadingLeaderboard,
        showBreadCrumbsData,
        problemWindowHeight,
        setSelectedLanguage,
        setIsVersionUpToDate,
        setCommentAttachment,
        setBreadCrumbsOption,
        isAdminSubmitTimeout,
        setRunTestResultCode,
        setTimeComplexityResult,
        setOutputWindowHeight,
        setLoadingLeaderboard,
        setProblemWindowHeight,
        setShowBreadCrumbsData,

        //coding end

        //zoom start

        topicId,
        tsCoBkup,
        showTimer,
        batchNames,
        lpGridView,
        setTopicId,
        searchValue,
        currentPage,
        setTsCoBkup,
        leaveMeeting,
        setShowTimer,
        participants,
        setBatchNames,
        showzoommodal,
        setLpGridView,
        batchGridView,
        showwarnmodal,
        showtransition,
        setSearchValue,
        setCurrentPage,
        downloadWidget,
        questionListObj,
        isDashBoardEdit,
        setparticipants,
        setshowzoommodal,
        setBatchGridView,
        setshowwarnmodal,
        setshowtransition,
        handleDisableUser,
        setDownloadWidget,
        ZoomBatchStudents,
        setIsDashBoardEdit,
        setZoomBatchStudents,
        showremovefromtestmodal,
        showremovefrombatchmodal,
        setshowzoommodalfunction,
        setshowwarnmodalfunction,
        currentDashboardMetaData,
        setshowremovefromtestmodal,
        setshowremovefrombatchmodal,
        setCurrentDashboardMetaData,
        currentEditDashboardMetaData,
        setCurrentEditDashboardMetaData,
        setshowremovefromtestmodalfunction,
        setshowremovefrombatchmodalfunction,

        // video qn

        mid,
        qns,
        data,
        lpcid,
        token,
        setMid,
        setQns,
        preview,
        lStatus,
        setData,
        libtype,
        hasMore,
        tesMode,
        filters,
        qnTrack,
        videoQn,
        setLpcid,
        resLData,
        isEditTC,
        settoken,
        dbStatus,
        videoQnNo,
        totalmids,
        verifyMsg,
        verifyImg,
        isEditJob,
        showBlink,
        startVideo,
        setPreview,
        setLStatus,
        isCCreator,
        CCTestData,
        setLibtype,
        setHasMore,
        setTesMode,
        isJoinZoom,
        setFilters,
        VideoSaved,
        setDbStatus,
        initialJobs,
        expandedJob,
        selectedBid,
        setResLData,
        studentPage,
        setIsEditTC,
        fromTrainer,
        contentType,
        openJobForm,
        dashBoardId,
        clcikedMenu,
        refreshToken,
        filteredJobs,
        setVerifyMsg,
        setTotalmids,
        isGrandTotal,
        matchqnCount,
        setHalfDonut,
        setVerifyImg,
        setIsEditJob,
        setShowBlink,
        setStartVideo,
        disableNxtBtn,
        isReportClick,
        exitVdoSubmit,
        setVideoSaved,
        setIsJoinZoom,
        showHalfDonut,
        setIsCCreator,
        setCCTestData,
        isFromProfile,
        timeVdoSubmit,
        showSubmitBtn,
        userProfilePic,
        handleResponse,
        setClickedMenu,
        updatingStates,
        currentEditJob,
        setExpandedJob,
        setInitialJobs,
        setContentType,
        halfDonutChart,
        setFromTrainer,
        setStudentPage,
        selectedStatus,
        setSelectedBid,
        setOpenJobForm,
        setDashboardId,
        showTranscript,
        competitiveData,
        setFilteredJobs,
        fromRecommended,
        setrefreshToken,
        studentDetailSL,
        setIsGrandTotal,
        singleVdoSubmit,
        PractSingleQnId,
        externalDevices,
        setIsReportClick,
        showInstructions,
        isPracticeRetake,
        PractSingleQnAns,
        practSingleQnAns,
        learnerVideoLink,
        setDisableNxtBtn,
        setShowTranscript,
        setUserProfilePic,
        setUpdatingStates,
        setCurrentEditJob,
        isCodingChallenge,
        setSelectedStatus,
        setHalfDonutChart,
        allWindowsBlurred,
        hideSubmitVideoQn,
        setExternalDevices,
        setCompetitiveData,
        setSingleVdoSubmit,
        setFromResommended,
        setStudentDetailSL,
        createCCSingleTest,
        testPageShowReload,
        showTranscriptFunc,
        openRecommendedList,
        setShowInstructions,
        setIsPracticeRetake,
        setPractSingleQnAns,
        setLearnerVideoLink,
        setHideSubmitVideoQn,
        setIsCodingChallenge,
        sectionWithQuestions,
        setTestPageShowReload,
        noPercentile,
        setNoPercentile,
        leaderboardTestDetail,
        setOpenRecommendedList,
        PractSingleQnFinalSubmit,
        setLeaderBoardTestDetail,
        isQuestionUploaded,
        setIsQuestionUploaded,
        companyInfo,
        setCompanyInfo,
        fetchCompanyData,
        setFetchCompanyData,
        companySearch,        
        setCompanySearch,
        showArchivedCompanies,
        setShowArchivedCompanies,
        setArchivedCompanyCount,
        archivedCompanyCount,
        streamRef,
        ActivityData,
        setActivityData,
        completeAssignmentsData,
        setCompleteAssignmentsData,
        selectedChapters,
        setSelectedChapters,
        selectedModule,
        setSelectedModule,
        hoveredModule,
        setHoveredModule,
        appliedModules,
        setAppliedModules,
        selectedDropdown,
        setSelectedDropdown,
        collegeList,
        setCollegeList,
        selectedcollege,
        setSelectedcollege,
        branchList,
        setBranchList,
        selectedBranch,
        setSelectedBranch,
        openCDropdown,
        setOpenCDropdown,
        openModuleDropdown,
        setOpenModuleDropdown,
        universityList,
        setUniversityList,
        selectedScope,
        setSelectedScope,
        mockTestReportTopic,
        setMockTestReportTopic,
        mockTestReportCurrentTopic,
        setMockTestReportCurrentTopic,
        showSupAdminControls, setShowSupAdminControls
      }}
    >
      {children}
    </AlertContext.Provider>
  );
};
export default AlertContext;


